<script setup lang="ts"></script>

<template>
    <div class="root">
        <slot />
    </div>
</template>

<style scoped lang="scss">
@include scroll-fantasy;
.root {
    overflow-x: hidden;
    :deep() {
        .content {
            max-width: 100%;
        }
        .table {
            overflow-x: scroll;
            @include scroll-fantasy;
            table {
                background-color: white;
                border-collapse: collapse !important;
                border-spacing: 0 !important;
                border: none !important;
                .header,
                .data {
                    white-space: nowrap;
                }
                overflow-y: auto;
                border-spacing: 0;
                max-height: 100%;
                tr {
                    @include tg-m($w7, usePalette());
                    border-collapse: collapse !important;
                    border-spacing: 0 !important;
                    th {
                        border-collapse: collapse !important;
                        border-spacing: 0 !important;
                        white-space: nowrap;
                        border: none !important;
                        &:first-child {
                            border-radius: 0 8px 8px 0;
                        }

                        &:last-child {
                            border-radius: 8px 0 0 8px;
                        }

                        padding: 4px 8px;
                        background-color: usePalette($p-cool-gray, $p-100);
                    }
                    td {
                        border-collapse: collapse !important;
                        border-spacing: 0 !important;
                        border: none !important;
                        white-space: nowrap;
                        padding: 8px;
                        @include tg-m($w5, usePalette($p-blue, $p-700));
                    }
                }
            }
        }
    }
}
</style>
